module.exports = __webpack_public_path__ + "static/media/88.1b356dfd.JPG";